import { GRID_TREE_DATA_GROUPING_FIELD } from '@mui/x-data-grid-pro';
import {
  TABLE_COLUMN_SYSTEM_FIELDS,
  type TableColumnIdentifier,
  type TableColumnSystemField,
} from '@tempo-io/roadmap-dto';
import { isFiniteNumber } from '@/common/utils/number';

const SYSTEM_FIELDS: ReadonlySet<TableColumnSystemField> = new Set(TABLE_COLUMN_SYSTEM_FIELDS);
const DELIMITER = '|';

export const buildTableColumnField = ({ type, customFieldId }: TableColumnIdentifier) =>
  type === 'name' ? GRID_TREE_DATA_GROUPING_FIELD : `${type}${DELIMITER}${customFieldId}`;

export const parseTableColumnField = (field: string): TableColumnIdentifier => {
  const [parsedType, parsedCustomFieldId] = field.split(DELIMITER);

  if (parsedType === GRID_TREE_DATA_GROUPING_FIELD) {
    return { type: 'name', customFieldId: null };
  }

  if (parsedType === 'customField') {
    const numericCustomFieldId = Number(parsedCustomFieldId);
    if (!isFiniteNumber(numericCustomFieldId)) {
      throw new Error(`Invalid custom field ID: ${parsedCustomFieldId}`);
    }
    return { type: 'customField', customFieldId: numericCustomFieldId };
  }

  if (!SYSTEM_FIELDS.has(parsedType as TableColumnSystemField)) {
    throw new Error(`Unknown column type: ${parsedType}`);
  }

  return { type: parsedType as TableColumnSystemField, customFieldId: null };
};
